import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const FormField = ({ 
  label, 
  required = false, 
  value, 
  onChange, 
  onBlur,
  placeholder = '',
  type = 'text',
  className = '',
  error = '',
  showError = false,
  digitsOnly = false
}) => {
  const handleChange = (e) => {
    let newValue = e.target.value;
    if (digitsOnly) {
      // Only allow digits (0-9)
      newValue = newValue.replace(/[^0-9]/g, '');
    }
    onChange(newValue);
  };

  return (
    <div className={`space-y-2 ${className}`}>
      <Label className="text-sm font-bold text-foreground flex items-center gap-0.5">
        {label}
        {required && <span className="text-destructive ml-0.5">*</span>}
      </Label>
      <Input 
        type={type}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        inputMode={digitsOnly ? 'numeric' : undefined}
        className={`h-11 px-4 border-input hover:border-muted-foreground/50 focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-0 focus-visible:border-accent transition-colors duration-200 ${
          showError && error 
            ? 'border-2 border-destructive bg-red-50 focus-visible:ring-destructive focus-visible:border-destructive' 
            : 'bg-background'
        }`}
      />
      {showError && error && (
        <p className="text-sm text-destructive flex items-center gap-1">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

export { FormField };
export default FormField;
